// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as BoardComponent} from './Board.svg';

import Icon, { TIconProps } from '../Icon';

export const IconBoard = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <BoardComponent/>
  </Icon>
));
